
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { Storage_$reflection, UpdateStorageDto_$reflection, CreateStorageDto_$reflection } from "../../Shared/Storage.js";
import { class_type, array_type, option_type, anonRecord_type, bool_type, string_type, record_type, list_type, union_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ClientApiResponse$1_$reflection, FormState_$reflection, AccountSettings_$reflection, CustomerConfiguration_$reflection, RequestedValue$1_$reflection } from "../../Shared/Shared.js";
import { Location_$reflection } from "../../Shared/Location.js";
import { User_$reflection } from "../../Shared/User.js";
import { BusinessUnitOverviewDto_$reflection } from "../../Shared/BusinessUnit.js";

export class DtoType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Create", "Update"];
    }
}

export function DtoType_$reflection() {
    return union_type("Storage.Form.Types.DtoType", [], DtoType, () => [[["Item", CreateStorageDto_$reflection()]], [["Item", UpdateStorageDto_$reflection()]]]);
}

export function DtoType__get_Name(this$) {
    if (this$.tag === 1) {
        return this$.fields[0].Name;
    }
    else {
        return this$.fields[0].Name;
    }
}

export function DtoType__get_Description(this$) {
    if (this$.tag === 1) {
        return this$.fields[0].Description;
    }
    else {
        return this$.fields[0].Description;
    }
}

export function DtoType__get_AssignedUserIds(this$) {
    if (this$.tag === 1) {
        return this$.fields[0].AssignedUserIds;
    }
    else {
        return this$.fields[0].AssignedUserIds;
    }
}

export function DtoType__get_AccessByUser(this$) {
    if (this$.tag === 1) {
        return this$.fields[0].AccessByUser;
    }
    else {
        return this$.fields[0].AccessByUser;
    }
}

export function DtoType__get_LocationId(this$) {
    if (this$.tag === 1) {
        return this$.fields[0].LocationId;
    }
    else {
        return this$.fields[0].LocationId;
    }
}

export function DtoType__get_IsSelfService(this$) {
    if (this$.tag === 1) {
        return this$.fields[0].IsSelfService;
    }
    else {
        return this$.fields[0].IsSelfService;
    }
}

export function DtoType__get_BusinessUnitId(this$) {
    if (this$.tag === 1) {
        return this$.fields[0].BusinessUnitId;
    }
    else {
        return this$.fields[0].BusinessUnitId;
    }
}

export class State extends Record {
    constructor(Storage, Locations, Configuration, Users, BusinessUnits, AccountSettings, Dto, FormState) {
        super();
        this.Storage = Storage;
        this.Locations = Locations;
        this.Configuration = Configuration;
        this.Users = Users;
        this.BusinessUnits = BusinessUnits;
        this.AccountSettings = AccountSettings;
        this.Dto = Dto;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("Storage.Form.Types.State", [], State, () => [["Storage", RequestedValue$1_$reflection(Storage_$reflection())], ["Locations", RequestedValue$1_$reflection(list_type(Location_$reflection()))], ["Configuration", RequestedValue$1_$reflection(CustomerConfiguration_$reflection())], ["Users", RequestedValue$1_$reflection(list_type(User_$reflection()))], ["BusinessUnits", RequestedValue$1_$reflection(list_type(BusinessUnitOverviewDto_$reflection()))], ["AccountSettings", RequestedValue$1_$reflection(AccountSettings_$reflection())], ["Dto", DtoType_$reflection()], ["FormState", FormState_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetName", "SetDescription", "SetIsSelfService", "SetLocation", "SetBusinessUnit", "AddUser", "AddUserToSelfServiceUsers", "SaveStorage", "UsersFetched", "LocationsFetched", "StorageFetched", "StorageUpdated", "StorageCreated", "ConfigurationFetched", "AccountSettingsFetched", "BusinessUnitsFetched", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Storage.Form.Types.Msg", [], Msg, () => [[["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", option_type(anonRecord_type(["label", string_type], ["value", Location_$reflection()]))]], [["Item", option_type(anonRecord_type(["label", string_type], ["value", BusinessUnitOverviewDto_$reflection()]))]], [["Item", option_type(array_type(anonRecord_type(["label", string_type], ["value", User_$reflection()])))]], [["Item", option_type(array_type(anonRecord_type(["label", string_type], ["value", User_$reflection()])))]], [], [["Item", list_type(User_$reflection())]], [["Item", list_type(Location_$reflection())]], [["Item", Storage_$reflection()]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", CustomerConfiguration_$reflection()]], [["Item", AccountSettings_$reflection()]], [["Item", list_type(BusinessUnitOverviewDto_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

